import { render, staticRenderFns } from "./FormOfPaymentListItem.vue?vue&type=template&id=1548ba81"
import script from "./FormOfPaymentListItem.vue?vue&type=script&lang=js"
export * from "./FormOfPaymentListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports